export default __webpack_public_path__ + "static/media/Transpiramide.c5eacc07.png";